module.exports = __webpack_public_path__ + "static/media/industry.fb33ddde.png";